import $ from 'jquery';
  
export default class VirtualCave {
    constructor() {
        this.$container = $('#cave');
        this.initEvents();
    }

    initEvents() {
        let SELF = this;
        // let $sectionsToHide = SELF.$container.find('.page-content > .elementor > .elementor-section:not(:first)');
        // this.$container.find('.elementor-tabs-wrapper').on('click', '.elementor-tab-title', function() {
        //     if($(this).data('tab') == 1) {
        //         $sectionsToHide.show();
        //     } else {
        //         $sectionsToHide.hide();
        //     }
        // });
        // this.$container.find('.elementor-tab-title.elementor-active').trigger('click');
    }
}